<template>
	<div class="mb-4 lg:pl-10 space-y-2 w-full">
		<div
			v-for="(product, index) in products"
			:key="index"
			class="group grid gap-2 md:gap-4 items-center py-2 relative grid-cols-[3.125rem_1fr_auto]"
			:class="isAuthenticated ? 'md:grid-cols-[3.75rem_1fr_13rem_10.625rem]' : 'md:grid-cols-[3.75rem_1fr_13rem_auto]'"
		>
			<figure class="w-[3.125rem] md:w-[3.75rem] h-[3.125rem] md:h-[3.75rem]">
				<NuxtImg
					v-if="product.imgIcon"
					class="w-full h-full object-contain"
					:src="product.imgIcon"
					:alt="product.name || ''"
					loading="lazy"
				/>
			</figure>
			<div class="max-sm:min-w-0 flex flex-col">
				<h3
					class="
						typo-h5 text-heading-secondary leading-[1.2rem] line-clamp-2
						max-sm:truncate max-sm:max-w-full max-sm:inline-block
					"
				>
					<AbsoluteInternalLink
						:to="branchSpecificPath({
							name: 'hypermarket-cela-nabidka-category-p-product',
							params: {product: createHouseProductSlug(product)},
						})"
						class="hover:text-body-important transition-colors duration-150 after:absolute after:bottom-0 after:inset-0 z-1"
						@click="handleProductClick(product)"
					>
						{{ product.name }}
					</AbsoluteInternalLink>
				</h3>
				<div class="md:hidden text-sm max-md:flex max-md:gap-x-2 max-md:flex-wrap">
					<ProductTriplePricing
						v-if="product.productInHouse"
						:product-in-house="product.productInHouse"
						small-price
					/>
				</div>
			</div>
			<div class="hidden md:flex md:items-center justify-end md:gap-x-4 px-2 md:px-4 lg:px-8 whitespace-nowrap md:w-52">
				<ProductRibbons :product="product" class="relative" />
				<div class="flex flex-wrap gap-x-2 md:flex-col min-w-[4rem] text-end">
					<ProductTriplePricing
						v-if="product.productInHouse"
						:product-in-house="product.productInHouse"
						small-price
					/>
				</div>
			</div>
			<div
				class="relative z-10 max-sm:w-auto justify-self-end"
				:class="isAuthenticated ? 'rem:w-[170px]' : 'rem:w-[130px]'"
			>
				<ProductShoppingListControl
					:product="product"
					:method="method"
					:inline-mobile-stepper="true"
					:is-shopping-list-open="openIndex === index"
					class="max-w-fit"
					@update:is-shopping-list-open="(val: boolean | undefined) => openIndex = val ? index : null"
				/>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import type {Gsoa_ProductCatalog_ProductDetail as GsoaProductCatalogProductDetail} from '~/openapi/models/Gsoa_ProductCatalog_ProductDetail';
	import {useSearchStore} from '~/stores/search';
	import {createHouseProductSlug} from '~/utils/createHouseProductSlug';
	import type {ShoppingListAddMethod} from '~/utils/tracking';

	interface Props {
		products: GsoaProductCatalogProductDetail[]
		method?: ShoppingListAddMethod
	}

	withDefaults(defineProps<Props>(), {method: 'search_result'});

	const {isAuthenticated} = useAuth();
	const searchStore = useSearchStore();
	const branchSpecificPath = useBranchSpecificPath();
	const openIndex = ref<number | null>(null);

	function setVisibleSearchPopup(state: boolean) {
		searchStore.setVisibleSearchPopup(state);
	}

	function handleProductClick(product: GsoaProductCatalogProductDetail) {
		trackEcommerceEvent('select_item', {items: mapProductsToGtmEvent([product])});
		setVisibleSearchPopup(false);
	}
</script>
